<template>
  <v-card hover @click="$router.push('/timeline/' + date)" style="cursor: pointer; display: flex; flex-direction: column;">
    <v-card-title style="padding-bottom: 5px;">
      <i class="fad fa-map-marked-alt" style="margin-right: 10px;"></i>
      {{ $t("timeline.header") }}
    </v-card-title>
    <v-card-subtitle style="padding-bottom: 5px;">
      <div>{{ path.length }} {{ $t("timeline.points_recorded") }}</div>
      <div v-if="primaryCity" style="font-weight: bold; color: var(--v-primary-base); margin-top: 4px;">
        <i class="fad fa-city" style="margin-right: 5px;"></i>{{ primaryCity }}
        <span v-if="additionalCitiesCount > 0" style="font-size: 12px; color: grey; font-weight: normal;">
          + {{ additionalCitiesCount }} {{ $t("timeline.more_cities") }}
        </span>
      </div>
    </v-card-subtitle>
    
    <div v-if="!loaded" style="text-align: center; height: 150px; display: flex; align-items: center; justify-content: center;">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
    <div v-else-if="path.length === 0" style="text-align: center; height: 150px; display: flex; align-items: center; justify-content: center; padding: 20px;">
      <p style="color: grey;">{{ $t("timeline.no_data_recorded_for_this_date_yet") }}</p>
    </div>
    <div v-else style="position: relative; overflow: hidden; flex-grow: 1; min-height: 150px;">
      <GmapMap
        ref="mapRef"
        :center="map_center"
        :zoom="map_zoom"
        map-type-id="roadmap"
        :options="mapOptions"
        style="width: 100%; height: 200px; pointer-events: none;"
      >
        <GmapPolyline
          :path.sync="path"
          :options="{ strokeColor: '#000' }"
        ></GmapPolyline>
      </GmapMap>
    </div>
  </v-card>
</template>

<script>
import Location from "../../logic/Location";
import { gmapApi } from "vue2-google-maps";
import { getMapOptions } from "../../mapStyles";

export default {
  props: {
    date: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      locations: [],
      path: [],
      primaryCity: null,
      additionalCitiesCount: 0
    };
  },
  computed: {
    google: gmapApi,
    mapOptions() {
      return getMapOptions(this.$vuetify.theme.dark);
    },
    map_center() {
      if (this.path.length === 0) return { lat: 0, lng: 0 };
      var lats = 0, lngs = 0;
      this.path.forEach(function (curr) {
        lats += curr.lat;
        lngs += curr.lng;
      });
      return { lat: lats / this.path.length, lng: lngs / this.path.length };
    },
    map_zoom() {
      if (this.path.length === 0) return 2;
      var GLOBE_WIDTH = 256;
      var pixelWidth = 400; // estimated card width
      var pixelHeight = 200; // estimated card height
      var west = 180, east = -180, north = 180, south = -180;
      
      this.path.forEach(function (curr) {
        if (curr.lng < west) west = curr.lng;
        if (curr.lng > east) east = curr.lng;
        if (curr.lat < north) north = curr.lat;
        if (curr.lat > south) south = curr.lat;
      });
      
      var angle = east - west;
      if (angle < 0) angle += 360;
      var angle2 = south - north;
      if (angle2 < 0) angle2 += 360;

      if (angle === 0 && angle2 === 0) return 15; // single point zoom level

      return (
        Math.round(
          (Math.round(
            Math.log((pixelWidth * 360) / angle / GLOBE_WIDTH) / Math.LN2
          ) +
            Math.round(
              Math.log((pixelHeight * 360) / angle2 / GLOBE_WIDTH) / Math.LN2
            )) /
            2
        ) - 2
      );
    }
  },
  watch: {
    date() {
      this.loadData();
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loaded = false;
      this.path = [];
      
      var response = await Location.get(this.date);
      if (response.isOK && response.data !== undefined) {
        this.locations = response.data;
        
        let cityCounts = {};
        
        this.locations.forEach((location) => {
          this.path.push({
            lat: parseFloat(location.data.lat),
            lng: parseFloat(location.data.lon)
          });
          
          let address = location.data.address;
          if (address) {
            let parts = address.split(',');
            let cityPart = parts.length > 1 ? parts[parts.length - 2].trim() : parts[0].trim();
            let city = cityPart.replace(/[0-9]/g, '').trim();
            if (city) {
              if (!cityCounts[city]) cityCounts[city] = 0;
              cityCounts[city]++;
            }
          }
        });
        
        let sortedCities = Object.keys(cityCounts).sort((a, b) => cityCounts[b] - cityCounts[a]);
        this.primaryCity = sortedCities.length > 0 ? sortedCities[0] : null;
        this.additionalCitiesCount = sortedCities.length > 1 ? sortedCities.length - 1 : 0;
        
      } else {
        this.locations = [];
        this.primaryCity = null;
        this.additionalCitiesCount = 0;
      }
      this.loaded = true;
    }
  }
};
</script>

<style scoped>
</style>
